import axios from "axios";
import { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bffy_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Silently award gamification points (only if logged in). Returns awarded amount.
export async function awardPoints(action, ref) {
  if (!localStorage.getItem("bffy_token")) return 0;
  try {
    const { data } = await api.post(`/me/award?action=${action}${ref ? `&ref=${encodeURIComponent(ref)}` : ""}`);
    return data.awarded || 0;
  } catch { return 0; }
}

// simple fetch hook for public content
export function useContent(type) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let ok = true;
    api.get(`/content/${type}`).then((r) => ok && setData(r.data)).catch(() => {}).finally(() => ok && setLoading(false));
    return () => { ok = false; };
  }, [type]);
  return { data, loading };
}
